export enum ComponentSize {
  XSmall = "xsmall",
  Small = "small",
  Medium = "medium",
  Large = "large"
}
